/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccessRightsProfile} from '../models/AccessRightsProfile';
import type {Error} from '../models/Error';

export interface GetAccessRightProfile$Request {
    profileId: number;
}

export interface GetAccessRightProfile$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccessRightProfileRequest = createAction<PayloadData<void, GetAccessRightProfile$Request>>('GET_ACCESS_RIGHT_PROFILE__GET_ACCESS_RIGHT_PROFILE__REQUEST');
export const getAccessRightProfileSuccess = createAction<PayloadData<AccessRightsProfile, GetAccessRightProfile$Request>>('GET_ACCESS_RIGHT_PROFILE__GET_ACCESS_RIGHT_PROFILE__SUCCESS');
export const getAccessRightProfileFailure = createAction<PayloadData<Error, GetAccessRightProfile$Request, true>>('GET_ACCESS_RIGHT_PROFILE__GET_ACCESS_RIGHT_PROFILE__FAILURE');

export const getAccessRightProfileActions = [
    getAccessRightProfileRequest,
    getAccessRightProfileSuccess,
    getAccessRightProfileFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccessRightProfile = (meta: GetAccessRightProfile$Request, config?: GetAccessRightProfile$Config) => {
    return {
        CALL_API: {
            types: getAccessRightProfileActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/profiles/${meta.profileId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

